
const API_BASE_URL = "https://uma.aasmo.in/api/admin"; // Replace with your base URL

export const API_ENDPOINTS = {
  REGISTER: `${API_BASE_URL}/register-user`,
  LOGIN: `${API_BASE_URL}/login`,

};
